const RemoveIcon = ({
  color = "var(--pink)",
  size = 24,
  onClick = () => {},
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M2.41675 5.58317H22.5834M9.75008 5.58317V4.6665C9.75008 3.93716 10.0398 3.23769 10.5555 2.72196C11.0713 2.20624 11.7707 1.9165 12.5001 1.9165C13.2294 1.9165 13.9289 2.20624 14.4446 2.72196C14.9603 3.23769 15.2501 3.93716 15.2501 4.6665V5.58317M7.91675 10.1665L8.83341 17.4998M17.0834 10.1665L16.1667 17.4998M12.5001 9.24984V18.4165M18.9167 22.0832H6.08341L4.25008 5.58317H20.7501L18.9167 22.0832Z"
        stroke={color}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RemoveIcon;
